import { fetchTariffPlanTypes, } from "@Api/CountrySettings/countryGroup";
import Button from "@Components/Button";
import Card from "@Components/Card";
import { ERROR } from "@Components/Toast";
import { Box, Typography } from "@mui/material";
import { addNotification } from "@Store/Actions/Notifications";
import React from "react";
import { connect } from "react-redux";
import styles from "./index.module.scss";
import { Form } from "./popup";
import Delete from "./popup/Delete/Delete";
import Table from "./table";
class TariffPlanTypes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showFormPopup: false,
            showDeletePopup: false,
            selectedPlan: undefined,
            plans: [],
            isFetching: false,
        };
    }
    componentDidMount() {
        this.onFetchNetworks();
    }
    onFetchNetworks = async () => {
        try {
            this.setState({ isFetching: true });
            const response = await fetchTariffPlanTypes({ skip: 0, take: 100 });
            if (response.items.length === 0) {
                return;
            }
            this.setState({ plans: response.items });
        }
        catch (error) {
            console.log("error", error);
            this.props.notify({
                title: "Error",
                description: "Failed to fetch tariff plan data",
                status: ERROR,
            });
            console.error("Failed to fetch tariff plan data", error);
        }
        finally {
            this.setState({ isFetching: false });
        }
    };
    closeFormPopup = (refresh) => {
        this.setState({ showFormPopup: false, selectedPlan: undefined });
        if (refresh) {
            this.onFetchNetworks();
        }
    };
    closeDeletePopup = (refresh) => {
        this.setState({ showDeletePopup: false, selectedPlan: undefined });
        if (refresh) {
            this.onFetchNetworks();
        }
    };
    render() {
        return (React.createElement(Card, { className: styles.card },
            React.createElement(Box, { sx: {
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "12px",
                    alignItems: "center",
                    padding: "18px 24px",
                    borderBottom: "1px solid #CCD4DC",
                } },
                React.createElement(Typography, { sx: {
                        fontWeight: 600,
                        fontSize: "14px",
                        lineHeight: "125%",
                        color: "#00A555",
                    } }, "Tariff Plan Type"),
                React.createElement("div", null,
                    React.createElement(Button, { disabled: false, type: "button", click: () => this.setState({
                            showFormPopup: true,
                            selectedPlan: undefined,
                        }) }, "ADD NEW TARIFF PLAN TYPE"))),
            React.createElement(Box, null,
                React.createElement(Table, { rows: this.state.plans, isLoading: this.state.isFetching, onEdit: (plan) => this.setState({
                        showFormPopup: true,
                        selectedPlan: plan,
                    }), onDelete: (plan) => this.setState({
                        showDeletePopup: true,
                        selectedPlan: plan,
                    }) })),
            React.createElement(Form, { open: this.state.showFormPopup, close: this.closeFormPopup, notify: this.props.notify, plan: this.state.selectedPlan }),
            React.createElement(Delete, { open: this.state.showDeletePopup, close: this.closeDeletePopup, notify: this.props.notify, plan: this.state.selectedPlan })));
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        notify: (data) => addNotification(dispatch, data),
    };
};
const mapStateToProps = () => ({});
export default connect(mapStateToProps, mapDispatchToProps)(TariffPlanTypes);
